import gql from 'graphql-tag';

export default gql`
    query GetAllDriversByMessage($input: DriverMessageInput, $offset: Int) {
        getAllDriversByMessage(input: $input, offset: $offset) {
            driverView {
                resultId
                name
                isShiftStarted
                isAssigned
                driverId
                driverCompanyName
                isRead
                cellPhone
                isWaitingOnLoad
                isLastLoadRejected
                CheckInWithBellyDump
                IsAvailable
            }
            totalCount
        }
    }
`;
